import React, { useState, useEffect } from 'react';
import '../../styles/reports/tasksummary.css';

const TaskSummary = () => {
  const [stats, setStats] = useState({ homeVisits: 0, immunizations: 0, ancVisits: 0, referrals: 0 });
  const [progress, setProgress] = useState({
    homeVisits: { completed: 0, total: 0, percentage: '0%' },
    immunizations: { completed: 0, total: 0, percentage: '0%' },
    ancVisits: { completed: 0, total: 0, percentage: '0%' },
    referrals: { completed: 0, total: 0, percentage: '0%' },
  });
  const [tasks, setTasks] = useState({ homeVisits: [], immunizations: [], ancVisits: [], referrals: [] });
  const [view, setView] = useState('This Month');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [statsRes, progressRes, tasksRes] = await Promise.all([
          fetch(`https://ashaapi.bluai.ai/api/asha/stats?view=${view}`),
          fetch(`https://ashaapi.bluai.ai/api/asha/progress?view=${view}`),
          fetch(`https://ashaapi.bluai.ai/api/asha/tasks?view=${view}`),
        ]);

        if (!statsRes.ok || !progressRes.ok || !tasksRes.ok) {
          throw new Error('Failed to fetch data');
        }

  const statsJson = await statsRes.json();
const progressJson = await progressRes.json();
const tasksJson = await tasksRes.json();

const statsData = statsJson.data;
const progressData = progressJson.data;
const tasksData = tasksJson.data;
        console.log('tasksData', tasksData);
        setStats(statsData);
        setProgress(progressData);
        setTasks(tasksData);
        setError(null);
      } catch (err) {
        setError('Failed to load task summary: ' + err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [view]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <>
      <div className="page-header">
        <h1 className="title">Task Summary</h1>
        <div className="date-selector">
          <span>View: </span>
          <select onChange={(e) => setView(e.target.value)} value={view}>
            <option>Today</option>
            <option>Tomorrow</option>
            <option>This Week</option>
            <option>This Month</option>
          </select>
        </div>
      </div>

      <div className="summary-section">
        <h2 className="summary-title">Task Overview</h2>
        <div className="summary-stats">
          <div className="stat-item">
            <div className="stat-icon" style={{ backgroundColor: '#E8F5E9', color: '#4CAF50' }}>
              <i className="fas fa-home"></i>
            </div>
            <div className="stat-value">{stats.homeVisits || 0}</div>
            <div className="stat-label">Home Visits</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ backgroundColor: '#E3F2FD', color: '#2196F3' }}>
              <i className="fas fa-syringe"></i>
            </div>
            <div className="stat-value">{stats.immunizations || 0}</div>
            <div className="stat-label">Immunizations</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ backgroundColor: '#F3E5F5', color: '#9C27B0' }}>
              <i className="fas fa-female"></i>
            </div>
            <div className="stat-value">{stats.ancVisits || 0}</div>
            <div className="stat-label">ANC Visits</div>
          </div>
          <div className="stat-item">
            <div className="stat-icon" style={{ backgroundColor: '#FFEBEE', color: '#F44336' }}>
              <i className="fas fa-hospital"></i>
            </div>
            <div className="stat-value">{stats.referrals || 0}</div>
            <div className="stat-label">Referrals</div>
          </div>
        </div>

        <div className="progress-container">
          <div className="progress-title">
            <div className="progress-label">Home Visits Progress</div>
            <div className="progress-value">
              {progress.homeVisits?.completed || 0}/{progress.homeVisits?.total || 0} ({progress.homeVisits?.percentage || '0%'})
            </div>
          </div>
          <div className="progress-bar">
            <div className="progress-fill fill-home" style={{ width: progress.homeVisits?.percentage || '0%' }}></div>
          </div>

          <div className="progress-title">
            <div className="progress-label">Immunizations Progress</div>
            <div className="progress-value">
              {progress.immunizations?.completed || 0}/{progress.immunizations?.total || 0} ({progress.immunizations?.percentage || '0%'})
            </div>
          </div>
          <div className="progress-bar">
            <div className="progress-fill fill-immunization" style={{ width: progress.immunizations?.percentage || '0%' }}></div>
          </div>

          <div className="progress-title">
            <div className="progress-label">ANC Visits Progress</div>
            <div className="progress-value">
              {progress.ancVisits?.completed || 0}/{progress.ancVisits?.total || 0} ({progress.ancVisits?.percentage || '0%'})
            </div>
          </div>
          <div className="progress-bar">
            <div className="progress-fill fill-anc" style={{ width: progress.ancVisits?.percentage || '0%' }}></div>
          </div>

          <div className="progress-title">
            <div className="progress-label">Referrals Progress</div>
            <div className="progress-value">
              {progress.referrals?.completed || 0}/{progress.referrals?.total || 0} ({progress.referrals?.percentage || '0%'})
            </div>
          </div>
          <div className="progress-bar">
            <div className="progress-fill fill-referral" style={{ width: progress.referrals?.percentage || '0%' }}></div>
          </div>
        </div>
      </div>

      <div className="tasks-grid">
        <div className="task-card-new">
          <div className="task-header">
            <div className="task-title">
              <div className="task-icon home-visit">
                <i className="fas fa-home"></i>
              </div>
              Home Visits
            </div>
            <div className="task-count count-home">{stats.homeVisits || 0}</div>
          </div>
          <div className="task-content">
            <ul className="task-list">
              {tasks.homeVisits?.map((task, index) => (
                <li className="task-item" key={index}>
                  <div className="task-info">
                    <div className="beneficiary-name">{task.name}</div>
                    <div className="beneficiary-details">{task.details}</div>
                  </div>
                  <div className={`task-status ${task.status === 'Due Today' ? 'status-due' : 'status-upcoming'}`}>
                    {task.status}
                  </div>
                </li>
              )) || <li>No tasks available</li>}
            </ul>
          </div>
          <div className="task-footer">
            <a href="#" className="view-all">
              View All Home Visits <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>

        <div className="task-card-new">
          <div className="task-header">
            <div className="task-title">
              <div className="task-icon immunization">
                <i className="fas fa-syringe"></i>
              </div>
              Immunizations
            </div>
            <div className="task-count count-immunization">{stats.immunizations || 0}</div>
          </div>
          <div className="task-content">
            <ul className="task-list">
              {tasks.immunizations?.map((task, index) => (
                <li className="task-item" key={index}>
                  <div className="task-info">
                    <div className="beneficiary-name">{task.name}</div>
                    <div className="beneficiary-details">{task.details}</div>
                  </div>
                  <div className={`task-status ${task.status === 'Due Today' ? 'status-due' : 'status-upcoming'}`}>
                    {task.status}
                  </div>
                </li>
              )) || <li>No tasks available</li>}
            </ul>
          </div>
          <div className="task-footer">
            <a href="#" className="view-all">
              View All Immunizations <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>

        <div className="task-card-new">
          <div className="task-header">
            <div className="task-title">
              <div className="task-icon anc">
                <i className="fas fa-female"></i>
              </div>
              ANC Visits
            </div>
            <div className="task-count count-anc">{stats.ancVisits || 0}</div>
          </div>
          <div className="task-content">
            <ul className="task-list">
              {tasks.ancVisits?.map((task, index) => (
                <li className="task-item" key={index}>
                  <div className="task-info">
                    <div className="beneficiary-name">{task.name}</div>
                    <div className="beneficiary-details">{task.details}</div>
                  </div>
                  <div className={`task-status ${task.status === 'Due Today' ? 'status-due' : 'status-upcoming'}`}>
                    {task.status}
                  </div>
                </li>
              )) || <li>No tasks available</li>}
            </ul>
          </div>
          <div className="task-footer">
            <a href="#" className="view-all">
              View All ANC Visits <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>

        <div className="task-card-new">
          <div className="task-header">
            <div className="task-title">
              <div className="task-icon referral">
                <i className="fas fa-hospital"></i>
              </div>
              Referrals
            </div>
            <div className="task-count count-referral">{stats.referrals || 0}</div>
          </div>
          <div className="task-content">
            <ul className="task-list">
              {tasks.referrals?.map((task, index) => (
                <li className="task-item" key={index}>
                  <div className="task-info">
                    <div className="beneficiary-name">{task.name}</div>
                    <div className="beneficiary-details">{task.details}</div>
                  </div>
                  <div className={`task-status ${task.status === 'Due Today' ? 'status-due' : 'status-upcoming'}`}>
                    {task.status}
                  </div>
                </li>
              )) || <li>No tasks available</li>}
            </ul>
          </div>
          <div className="task-footer">
            <a href="#" className="view-all">
              View All Referrals <i className="fas fa-arrow-right"></i>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default TaskSummary;